<chatV2-view *ngIf="type==='consultationSession' && consultationSession" title="Consultation"
    [chatUniqueObject]="consultationSession" [where]="{ user, consultationSession }"
    dataFunctionName="findConsultationSessionChat"></chatV2-view>
<chatV2-view *ngIf="type==='followUp' && followUp" title="Monthly Check-up" [chatUniqueObject]="followUp"
    [where]="{ user, followUp }" dataFunctionName="findFollowUpChat"></chatV2-view>
<chatV2-view *ngIf="type==='order' && order" title="Order" [chatUniqueObject]="order" [where]="{ user, order }"
    [disableChat]="true" dataFunctionName="findOrderChat"></chatV2-view>
<chatV2-view *ngIf="type==='supportTicket'
 && supportTicket" [title]='supportTicket?.get("title")' [chatUniqueObject]="supportTicket"
    [where]="{ user, supportTicket }" dataFunctionName="fetchSupportChat"></chatV2-view>